import React, { Component } from 'react';

import membershipStore from '../../stores/membershipStore';
import { T } from '../../stores/textStore';


export default class extends Component {
	componentDidMount() {
		membershipStore.alerts.replace([]);
	}

	render() {				
		return (
			<span>
				<div
						className="container-fluid text-white"
						style={{
							backgroundImage: 'url(https://my.kabbalah.com/images/placeholders/membership-widget/membership-success.jpg)',
							backgroundSize: 'cover',
							backgroundPosition: '100% 50%',
							minHeight: '800px',							
						}}
				>
					<div className="container py-5">
						<div className="row pb-5">
							<div className="col-lg-5 offset-lg-7">
								<h1 className="display-4 font-weight-bold" style={{ textShadow: '1px 1px 2px #000000' }}>
									{T('Welcome to Kabbalah.com!')}
								</h1>
								<h1 className="display-4 font-weight-bold" style={{ textShadow: '1px 1px 2px #000000' }}>
									{T('Thank you for joining us!')}
								</h1>								
								<h6 className="font-weight-bold mt-5" style={{ textShadow: '1px 1px 2px #000000' }}>
									{T('Start studying the wisdom of Kabbalah and start living your best life now!')}
								</h6>								
								<a
										href="/" 
										className="btn tkc-btn-outline-gold-dark font-weight-bold rounded-0"
										style={{ fontSize: '20px' }}
								>
									{T('Let’s Go')}
								</a>
							</div>
						</div>
					</div>
				</div>
				{/*
				<div className="container">				
					<div className="row">
						<div className="col-12">	
							<div style={{ position: 'relative' }}>
								<img 
										src="https://my.kabbalah.com/images/placeholders/membership-widget/membership-success.jpg" 
										className="w-100 d-none d-lg-inline"
								/>	
								<div 
									className="d-block d-lg-none"
									style={{ 
										minHeight: '400px',
										backgroundImage: 'url(https://my.kabbalah.com/images/placeholders/membership-widget/membership-success.jpg)',
										backgroundPosition: '50% 50%',
										backgroundSize: 'cover',
									}}
								>								
								</div>								
								<div style={{ position: 'absolute', top: '25%', left: '10%', maxWidth: '380px' }}>
									<h4 className="text-white" style={{ textShadow: '1px 1px 2px #000000' }}>
										{T('Welcome to Kabbalah.com!')}
									</h4>
									<h4 className="text-white" style={{ textShadow: '1px 1px 2px #000000' }}>
										{T('Thank you for joining us!')}
									</h4>	
									<p className="text-white mt-4" style={{ textShadow: '1px 1px 2px #000000' }}>
										{T('Start studying the wisdom of Kabbalah and start living your best life now!')}
									</p>					
									<a 
											href="/" 
											className="btn tkc-btn-red font-weight-bold rounded-0 mt-3"									
									>
										{T('Let’s Go')}
									</a>
								</div>
							</div>										
						</div>
					</div>
				</div>
				*/}
			</span>
		);
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/SuccessView.js